/**
 * 区分 dateStyleType（numbering_rules.date_style_type）
 * 出典：要件書 5.2（値は 02 D-091。日本語は 5.3.21 の説明から）
 */
export const DATE_STYLE_TYPE_VALUES = ['yearOnly', 'yearMonth'] as const;

export type DateStyleType = (typeof DATE_STYLE_TYPE_VALUES)[number];

export const DATE_STYLE_TYPE_LABELS: Readonly<Record<DateStyleType, string>> = {
  yearOnly: '年のみ',
  yearMonth: '年と月',
};
